module.exports = __webpack_public_path__ + "img/scene1-5.32be5181.jpg";